import React, { Component } from 'react';
import { TagsInput, AutoComplete } from '../../shared-components';
import { GaContext } from '../../../googleAnalyticsContext/GaContext';
import PropTypes from 'prop-types';
import {withFirebase} from '../../../Firebase';
import moment from 'moment';
import {
  BOOLEAN_AND,
  BOOLEAN_OR,
  BOOLEAN_NOT,
  KEY_FOR_KEYWORDS_JSON, 
  SINGAPORE_CATEGORY_NAME,
  KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE,
  KEY_FOR_CATEGORIES,
  KEY_FOR_ESTIMATED_PROCESSING_TIME_IN_HOURS,
  ADD_NEW_KEYWORD_TOPIC_ACTION_TYPE
} from '../redux/constants';
import {
  TOPIC_NAME_MISSING_ERROR_KEY,
  TOPIC_NAME_EXISTS_ERROR_KEY,
  MAXIMUM_TOPIC_NAME_LENGTH
} from './constants/constants';
import TopicPreview from './TopicPreview';
import { getUserEmailFromLocalStorage } from '../../../Firebase/localStorageForUserInfo';
import SingleDateCalendar from './SingleDateCalendar';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { ADD_TOPIC_I18N_KEYS as MY_I18N_KEYS, TOPICS_I18N_PREFIX as MY_I18N_PREFIX } from './constants/i18n/AddTopici18nConstants';

const EDIT_TOPIC_TYPE_TAG = 'edit';
const initialEarliestHistoricalDataDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
const initialState = {
  topicName: '',
  description: '',
  [KEY_FOR_KEYWORDS_JSON]: { [BOOLEAN_AND] :[{[BOOLEAN_OR]: []},{[BOOLEAN_OR]: []},{[BOOLEAN_NOT]: []}]},
  categories: [SINGAPORE_CATEGORY_NAME],
  status: false,
  retrieveTopicPreviewBegin: false,
  earliestHistoricalDataDate: '',
  estimatedProcessingTimeInHours: 0,
  hasUploadedData: false,
  hasCrawledData: true
};

class AddTopic extends Component {
  static propTypes = {
    show:                                       PropTypes.bool.isRequired,
    toggleModal:                                PropTypes.oneOfType([PropTypes.bool,PropTypes.func]).isRequired,
    type:                                       PropTypes.string.isRequired,
    createTopics:                               PropTypes.func.isRequired,
    retrieveTopicPreview:                       PropTypes.func.isRequired,
    topicData:                                  PropTypes.object.isRequired,
    allCategories:                              PropTypes.array.isRequired,
    resetAddTopicForm:                          PropTypes.bool.isRequired,
    createTopicsBeginStatus:                    PropTypes.oneOfType([PropTypes.bool,PropTypes.func]).isRequired,
    updateTopicsBegin:                          PropTypes.oneOfType([PropTypes.bool,PropTypes.func]).isRequired,
    allTopicNames:                              PropTypes.array.isRequired,
    topicPreviewPosts:                          PropTypes.array.isRequired,
    topicPreviewTotalPostsCount:                PropTypes.number,
    topicPreviewTotalCommentsCount:             PropTypes.number,
    topicPreviewEstimatedProcessingTimeInHours: PropTypes.number,
    retrieveTopicPreviewBegin:                  PropTypes.bool.isRequired,
    retrieveTopicPreviewSuccess:                PropTypes.bool.isRequired,
    retrieveTopicPreviewFailure:                PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      error: {},
      topicData: JSON.parse(JSON.stringify(initialState)),
      topicDataSentForEstimation: null,
      originalTopicName: null,
      allTopicNames: [],
      sendEmailWhenReady: false,
      showTopicPreview: false,
      retrieveTopicPreviewBegin: false
    };
  }

  getI18nAbsoluteKey(relativeKey) {
    return MY_I18N_PREFIX + "." + relativeKey;
  }

  getI18nText(relativeKey) {
    const absoluteKey = this.getI18nAbsoluteKey(relativeKey);
    return t(absoluteKey);
  }

  formSubmit = event => {
    event.preventDefault();
    this.setEstimatedProcessingTimeInHours();
    const { topicData } = this.state;
    const { createTopics } = this.props;
    if (this.validateAddTopicForm()) {
       return false;
    } else {
       createTopics(topicData);
    }
  };

  setEstimatedProcessingTimeInHours = () => {
    let { topicData, topicDataSentForEstimation } = this.state;
    if (!this.props.topicPreviewEstimatedProcessingTimeInHours || !topicDataSentForEstimation) {
      return;
    }
    if (this.isSubmittedTopicDataAndTopicDataUsedForEstimationTheSame(topicData, topicDataSentForEstimation)) {
      topicData[KEY_FOR_ESTIMATED_PROCESSING_TIME_IN_HOURS] = this.props.topicPreviewEstimatedProcessingTimeInHours;
      this.setState({
        topicData
      });
    }
  }

  isSubmittedTopicDataAndTopicDataUsedForEstimationTheSame = (topicData, topicDataSentForEstimation) => {
    let submittedKeywordsForTopicCreation = JSON.stringify(topicData[KEY_FOR_KEYWORDS_JSON]);
    let keywordsUsedInEstimationString = topicDataSentForEstimation[KEY_FOR_KEYWORDS_JSON];
    let areKeywordsTheSame = (submittedKeywordsForTopicCreation === keywordsUsedInEstimationString);
    
    let isEarliestHistoricalDataDateTheSame = (topicData[KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE] === topicDataSentForEstimation[KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE]);

    let areCategoriesTheSame = (topicData[KEY_FOR_CATEGORIES] === topicDataSentForEstimation[KEY_FOR_CATEGORIES]);

    return areKeywordsTheSame && isEarliestHistoricalDataDateTheSame && areCategoriesTheSame;

  }

  retrieveTopicPreviewSubmit = event => {
    event.preventDefault();
    const { topicData }            = this.state;
    const { retrieveTopicPreview } = this.props;
    if (this.validateAddTopicForm()) {
      return false;
    } else {
      retrieveTopicPreview(topicData);
      let topicKeywordsString = JSON.stringify(topicData[KEY_FOR_KEYWORDS_JSON]);
      const topicDataSentForEstimation = {
        [KEY_FOR_KEYWORDS_JSON]:                 topicKeywordsString,
        [KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE]: topicData[KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE],
        [KEY_FOR_CATEGORIES]:                    topicData[KEY_FOR_CATEGORIES]
      };
      this.setState({
        topicDataSentForEstimation: topicDataSentForEstimation
      });
    }
  }

  validateAddTopicForm = () => {
    let formError     = false;
    let { topicData } = this.state;
    let error         = {};
    if (!topicData.topicName) {
      error['topicNameMissing'] = true;
      formError = true;
    }
    if (this._isTopicNameAlreadyTaken(topicData.topicName)) {
      error['topicNameAlreadyExists'] = true;
      formError = true;
    }
    error[KEY_FOR_KEYWORDS_JSON] = [];
    for (let i=0;i < topicData.keywordsJSON[BOOLEAN_AND].length;i++) {
      const keywordClauseDict = topicData.keywordsJSON[BOOLEAN_AND][i];
      if (!  keywordClauseDict.hasOwnProperty(BOOLEAN_OR)) {
        continue;
      }
      if (! keywordClauseDict[BOOLEAN_OR].length) {
        error[KEY_FOR_KEYWORDS_JSON][i] = true;
        formError = true;
      }
      else {
        error[KEY_FOR_KEYWORDS_JSON][i] = false;
      }
    }
    if (topicData.description && topicData.description.length > 150) {
      error['description'] = true;
      formError = true;
    }
    if (!topicData.earliestHistoricalDataDate) {
      error[KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE] = true;
      formError = true;
    }
    this.setState({ error });
    return formError;
  };

  _isTopicNameAlreadyTaken(topicName) {
    const {originalTopicName, allTopicNames} = this.state;
    if (allTopicNames.includes(topicName) && (topicName !== originalTopicName)) {
      return true;
    }
    else {
      return false;
    }
  }

  selectedTags = (value, key) => {
    let { topicData, error } = this.state;
    topicData[key] = value;
    if (value.length) delete error[key];
    this.setState({ topicData, error });
  };

  selectedTagsForKeywordsJSON = (value, index) => {
    let { topicData, error }                                    = this.state;
    const keywordClause                                         = topicData.keywordsJSON[BOOLEAN_AND][index];
    const booleanOperator                                       = Object.keys(keywordClause);
    topicData.keywordsJSON[BOOLEAN_AND][index][booleanOperator] = value;
    if (value.length && error && error.keywordsJSON && error.keywordsJSON.length > index) {
      delete error.keywordsJSON[index];
    }
    this.setState({ topicData, error });
  };

  addKeywordsClause = () => {
    let { topicData }   = this.state;
    const indexToInsert = topicData.keywordsJSON[BOOLEAN_AND].length -1;
    topicData.keywordsJSON[BOOLEAN_AND].splice(indexToInsert,0,{[BOOLEAN_OR]:[]});
    this.setState({topicData});
  }

  removeKeywordClause = (index) => {
    let { topicData, error} = this.state;
    topicData.keywordsJSON[BOOLEAN_AND].splice(index,1);
    if (error && error.keywordsJSON && error.keywordsJSON.length > index) {
      delete error.keywordsJSON[index];
    }
    this.setState({topicData});
  }

  setFormValues = event => {
    let { topicData, error } = this.state;
    if (event.target.name === 'description' && event.target.value.length >= 150) {
      event.target.value.slice(0, 150);
      return false;
    }
    topicData[event.target.name] = event.target.value;
    delete error[event.target.name];
    this.setState({
      error,
      topicData,
    });
  };

  setEarliestHistoricalDataDate = (earliestHistoricalDataDate) => {
    let { topicData, error } = this.state;
    if (earliestHistoricalDataDate) {
      delete error[KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE];
      topicData[KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE] = earliestHistoricalDataDate; 
      this.setState({
        error,
        topicData
      });
    }
  }

  setWhetherAndWhereToEmailWhenTopicReady() {
    const previousSendEmailWhenReadyState        = this.state.sendEmailWhenReady;
    const newSendEmailWhenReadyState             = !previousSendEmailWhenReadyState;
    const topicReadyNotificationEmailAddress     = (newSendEmailWhenReadyState === true) ? getUserEmailFromLocalStorage() : null;
    let { topicData }                            = this.state;
    topicData.topicReadyNotificationEmailAddress = topicReadyNotificationEmailAddress;

    this.setState({
        sendEmailWhenReady: newSendEmailWhenReadyState,
        topicData:          topicData
    });
  }

  componentWillUnmount() {
    this.setState({ topicData: JSON.parse(JSON.stringify(initialState)) });
    document.body.classList.remove('modal-open');
  }
 
  static contextType =GaContext
  componentDidMount() {
    this._setAllTopicNamesIfNeeded(this.props);
    this._setOriginalTopicNameIfNeeded(this.props);

    const {ReactGA} = this.context;
    ReactGA.pageview('/dashboard/topics/addTopic');
    if (this.props.show) {
      document.body.classList.add('modal-open');
    }
    if (this.props.type === EDIT_TOPIC_TYPE_TAG) {
      let parsedTopicData = this._initiateKeywordsAndEarliestHistoricalDataDateForExistingTopicWithNoCrawledDataIfNeeded(this.props.topicData);
      this.setState({
        topicData: parsedTopicData,
        sendEmailWhenReady: !!parsedTopicData.topicReadyNotificationEmailAddress
      });
    }
    else {
      this.setEarliestHistoricalDataDate(initialEarliestHistoricalDataDate);
    }
  }

  _setOriginalTopicNameIfNeeded(nextProps) {
    if (nextProps.topicData && nextProps.topicData.topicName) {
      this.setState({originalTopicName: nextProps.topicData.topicName});
    }
  }

  _setAllTopicNamesIfNeeded(nextProps) {
    if (nextProps.allTopicNames && nextProps.allTopicNames.length) {
      this.setState({allTopicNames: nextProps.allTopicNames});
    }
  }

  _initiateKeywordsAndEarliestHistoricalDataDateForExistingTopicWithNoCrawledDataIfNeeded(topicData) {
    let parsedTopicData = JSON.parse(JSON.stringify(topicData));
    if (parsedTopicData.keywordsJSON === null) {
      parsedTopicData.keywordsJSON = { [BOOLEAN_AND] :[{[BOOLEAN_OR]: []},{[BOOLEAN_OR]: []},{[BOOLEAN_NOT]: []}]};
    }
    if (parsedTopicData.earliestHistoricalDataDate === "-") {
      parsedTopicData.earliestHistoricalDataDate = initialEarliestHistoricalDataDate;
    }
    return parsedTopicData;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this._setAllTopicNamesIfNeeded(nextProps);
    this._setRetrieveTopicPreviewBeginToStateIfNeeded(nextProps);

    if (
      JSON.stringify(nextProps.topicData) !== JSON.stringify(this.state.topicData) &&
      nextProps.type === EDIT_TOPIC_TYPE_TAG &&
      (! (
        nextProps.retrieveTopicPreviewBegin ||
        nextProps.retrieveTopicPreviewSuccess ||
        nextProps.retrieveTopicPreviewFailure
      ))
    ) {
      let parsedTopicData = this._initiateKeywordsAndEarliestHistoricalDataDateForExistingTopicWithNoCrawledDataIfNeeded(nextProps.topicData);
      this.setState({
        topicData: parsedTopicData,
        sendEmailWhenReady: !!parsedTopicData.topicReadyNotificationEmailAddress
      });
    }

    if (nextProps.resetAddTopicForm) {
      this.setState({ topicData: JSON.parse(JSON.stringify(initialState)), error: {} });
    }
  }

  _setRetrieveTopicPreviewBeginToStateIfNeeded(nextProps){
    if (nextProps.retrieveTopicPreviewBegin !== this.state.retrieveTopicPreviewBegin) {
      this.setState({ retrieveTopicPreviewBegin: nextProps.retrieveTopicPreviewBegin });
    }
  }

  _returnEarliestHistoricalDataDateBasedOnActionType(){
    const { type } = this.props;
    const { topicData } = this.state;
    const earliestHistoricalDataDateInTopicData = topicData[KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE];
    if (type === EDIT_TOPIC_TYPE_TAG){
      return earliestHistoricalDataDateInTopicData;
    }
    else if (earliestHistoricalDataDateInTopicData){
      return earliestHistoricalDataDateInTopicData;
    }
    return initialEarliestHistoricalDataDate;
  }

  isThereTopicNameFormError(error) {
    return (error[TOPIC_NAME_MISSING_ERROR_KEY] || error[TOPIC_NAME_EXISTS_ERROR_KEY]);
  }

  render() {
    const {
      toggleModal,
      type,
      show,
      createTopicsBeginStatus,
      allCategories,
      updateTopicsBegin
    } = this.props;
    const { topicData, sendEmailWhenReady, retrieveTopicPreviewBegin, error } = this.state;
    const earliestHistoricalDataDate = this._returnEarliestHistoricalDataDateBasedOnActionType();

    return (
      <div className={`modal add-topics ${show ? 'modal-show' : 'modal-hide'}`}>
        <div className="modal-dialog">
            <div className="modal-content">
              <div className="row">
              <div className="col-sm-7">
              <div className="modal-header">
                <h4 className="modal-title">
                  {type === ADD_NEW_KEYWORD_TOPIC_ACTION_TYPE ? this.getI18nText(MY_I18N_KEYS.add_topic) : this.getI18nText(MY_I18N_KEYS.edit_topic)}
                </h4>
                <i className="la la-close modal-close" onClick={() => toggleModal(false)} />
              </div>
              <form noValidate onSubmit={e => this.formSubmit(e)}>
                <div className="modal-body" id="create-edit-topic-form">
                  <div className="form-group row">
                    <div className="col-sm-12">
                      <span style={{'fontSize':'16px','fontWeight':'bold','color':'#666666'}}>
                      </span>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">{this.getI18nText(MY_I18N_KEYS.topic_name)}</label>
                    <div className="col-sm-8 topic-input-group">
                      <input
                        type="text"
                        maxLength={MAXIMUM_TOPIC_NAME_LENGTH}
                        className={`form-control add-topic-input ${
                          error && this.isThereTopicNameFormError(error) ? 'input-error' : ''
                        }`}
                        defaultValue={topicData.topicName}
                        name="topicName"
                        onChange={e => this.setFormValues(e)}
                      />
                    </div>
                    {error && error.topicNameMissing ? (
                      <span className="instruction-msg error">
                        {this.getI18nText(MY_I18N_KEYS.topic_name_missing_error)}
                      </span>
                    ) : error && error.topicNameAlreadyExists ? (
                      <span className="instruction-msg error">
                        {this.getI18nText(MY_I18N_KEYS.topic_name_already_exists_error)}
                      </span>
                    ) : (
                      <span className="instruction-msg">{this.getI18nText(MY_I18N_KEYS.topic_name_instructions)}</span>
                    )}
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label"> {this.getI18nText(MY_I18N_KEYS.description)}</label>
                    <div className="col-sm-8 topic-input-group">
                      <textarea
                        className="form-control add-topic-input"
                        value={topicData.description}
                        name="description"
                        onChange={e => this.setFormValues(e)}
                      ></textarea>
                    </div>
                    <span className="instruction-msg">{this.getI18nText(MY_I18N_KEYS.description_instructions)}</span>
                  </div>
                  {topicData.keywordsJSON && topicData.keywordsJSON[BOOLEAN_AND].map((keywordClauseDict, index) => (
                    <div className="form-group row" key={index}>
                      { keywordClauseDict.hasOwnProperty(BOOLEAN_NOT) && (
                        <label className="col-sm-4 col-form-label">{this.getI18nText(MY_I18N_KEYS.none_of_these_keywords)}</label>
                      )}
                      { keywordClauseDict.hasOwnProperty(BOOLEAN_OR) && (
                        <label className="col-sm-1 col-form-label">
                          {index === 0 ? (
                            <i />
                          ) : (
                            <i className="la la-times-circle-o" style={{'cursor':'pointer'}}
                               onClick={() => this.removeKeywordClause(index)}
                            />
                          )}
                        </label>
                      )}

                      { keywordClauseDict.hasOwnProperty(BOOLEAN_OR) && (
                        <label className="col-sm-3 col-form-label keyword-input-label">
                          {index !== 0 ? (
                            <span>
                              <Trans i18nKey={this.getI18nAbsoluteKey(MY_I18N_KEYS.and_any_of_these_keywords)}>
                                {this.getI18nText(MY_I18N_KEYS.and_any_of_these_keywords)}
                              </Trans>
                            </span>
                          ):(
                            <span>
                              <Trans i18nKey={this.getI18nAbsoluteKey(MY_I18N_KEYS.any_of_these_keywords)}>
                                {this.getI18nText(MY_I18N_KEYS.any_of_these_keywords)}
                              </Trans>
                            </span>
                          )}
                        </label>
                      )}

                      <div className="col-sm-8 topic-input-group">
                        <div
                          className={`add-topic-input ${
                            error && error.keywordsJSON && (error.keywordsJSON.length > index) && error.keywordsJSON[index] ? 'input-error' : ''
                          }`}
                        >
                          <TagsInput
                            placeholder={this.getI18nText(MY_I18N_KEYS.press_comma_to_add_keywords)}
                            selectedTags={e => this.selectedTagsForKeywordsJSON(e, index)}
                            tagData={keywordClauseDict[Object.keys(keywordClauseDict)[0]]}
                            key={index}
                          />
                        </div>
                      </div>
                      {keywordClauseDict.hasOwnProperty(BOOLEAN_OR) ? (
                        <span
                          className={`instruction-msg 
                            ${(error && error.keywordsJSON && (error.keywordsJSON.length > index) && error.keywordsJSON[index]) 
                            && "error"
                          }`}
                        >
                        <Trans i18nKey={this.getI18nAbsoluteKey(MY_I18N_KEYS.topic_keywords_instructions)} >
                          {this.getI18nText(MY_I18N_KEYS.topic_keywords_instructions)}
                        </Trans>
                        </span>
                      ) : keywordClauseDict.hasOwnProperty(BOOLEAN_NOT) && (
                        <span className="instruction-msg">
                          <Trans i18nKey={this.getI18nAbsoluteKey(MY_I18N_KEYS.exclude_keywords_instructions)}>
                              {this.getI18nText(MY_I18N_KEYS.exclude_keywords_instructions)}
                          </Trans>
                        </span>
                      )}
                    </div>
                  ))}
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">{this.getI18nText(MY_I18N_KEYS.categories)}</label>
                    <div className="col-sm-8 topic-input-group">
                      <div className="add-topic-input">
                        <AutoComplete
                          suggestions={allCategories}
                          placeholder="Please add category"
                          selectedTags={e => this.selectedTags(e, 'categories')}
                          tagData={topicData['categories']}
                        />
                      </div>
                    </div>
                    <span className="instruction-msg">
                      <Trans
                        i18nKey={this.getI18nAbsoluteKey(MY_I18N_KEYS.categories_instructions)}
                        components={{ b: <b /> }}
                      >
                          {this.getI18nText(MY_I18N_KEYS.categories_instructions)}
                      </Trans>
                    </span>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">{this.getI18nText(MY_I18N_KEYS.earliest_historical_data_date)}</label>
                    <div className="col-sm-8">
                      <SingleDateCalendar
                        earliestHistoricalDataDate = {earliestHistoricalDataDate} 
                        setEarliestHistoricalDataDate = {e => this.setEarliestHistoricalDataDate(e)}
                        drops="up"
                        showRanges={true}
                      />
                    </div>
                    {error && error.earliestHistoricalDataDate && (
                      <span className="instruction-msg error"> {this.getI18nText(MY_I18N_KEYS.earliest_historical_data_date_error)}</span>
                    )}
                    <span className="instruction-msg">
                      {this.getI18nText(MY_I18N_KEYS.earliest_historical_data_date_instructions_part_1)}<br/>
                      <i className="la la-lightbulb-o icon"></i>{this.getI18nText(MY_I18N_KEYS.earliest_historical_data_date_instructions_part_2)}
                    </span>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label"> {this.getI18nText(MY_I18N_KEYS.email_when_ready)}</label>
                    <div className="col-sm-8 topic-input-group">
                      <input
                        className="styled-checkbox"
                        type="checkbox"
                        id="email-checkbox"
                        onChange={() => this.setWhetherAndWhereToEmailWhenTopicReady()}
                        checked={sendEmailWhenReady}
                      />
                    </div>
                    <span className="instruction-msg">
                      {this.getI18nText(MY_I18N_KEYS.email_when_ready_instructions)}
                    </span>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label mandatory-msg">
                      {this.getI18nText(MY_I18N_KEYS.asterisk_denotes_mandatory_field)}
                    </label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    style={{'width':'100px'}}
                    className={`btn ${
                      createTopicsBeginStatus || updateTopicsBegin ? 'disabled' : ''
                    }`}
                    onClick={() => toggleModal(false)}
                  >
                    {this.getI18nText(MY_I18N_KEYS.cancel_button_text)}
                  </button>
                  <button className={`btn`}
                          type={`button`}
                          style={{'width':'168px'}}
                      onClick={() => this.addKeywordsClause()}
                  >
                    {this.getI18nText(MY_I18N_KEYS.add_keyword_group_button_text)}
                  </button>
                  <button className={`btn btn-submit ${this.state.retrieveTopicPreviewBegin ? 'disabled' : '' }`}
                          style={{'width':'168px'}}
                          onClick={(e) => this.retrieveTopicPreviewSubmit(e)}
                          type="submit"
                  >
                    {this.getI18nText(MY_I18N_KEYS.estimate_and_preview_button_text)}
                  </button>
                  <button
                    type="submit"
                    style={{'width':'100px'}}
                    className={`btn btn-submit ${
                      createTopicsBeginStatus || updateTopicsBegin || retrieveTopicPreviewBegin ? 'disabled' : ''
                    }`}
                  >
                    {(createTopicsBeginStatus || updateTopicsBegin) && (
                      <i className="la la-spinner la-spin" />
                    )}
                    {this.getI18nText(MY_I18N_KEYS.save_button_text)}
                  </button>
                </div>
              </form>
            </div>
                <div className="col-sm-5" style={{'backgroundColor':'rgba(0,0,0,.05)'}}>
                  <TopicPreview
                    topicPreviewPosts={this.props.topicPreviewPosts}
                    topicPreviewTotalPostsCount={this.props.topicPreviewTotalPostsCount}
                    topicPreviewTotalCommentsCount={this.props.topicPreviewTotalCommentsCount}
                    topicPreviewEstimatedProcessingTimeInHours={this.props.topicPreviewEstimatedProcessingTimeInHours}
                    retrieveTopicPreviewBegin={this.props.retrieveTopicPreviewBegin}
                    retrieveTopicPreviewSuccess={this.props.retrieveTopicPreviewSuccess}
                    retrieveTopicPreviewFailure={this.props.retrieveTopicPreviewFailure}
                    topicKeywordsJSON={this.state.topicData.keywordsJSON}
                  />
                </div>
              </div>
            </div>
        </div>
      </div>
    );
  }
}

export default withFirebase(AddTopic);



// WEBPACK FOOTER //
// ./src/features/topics/components/AddTopic.js